import { Component } from '@angular/core';

@Component({
  selector: 'app-ers-app-instance',
  templateUrl: './ers-app-instance.component.html',
  styleUrl: './ers-app-instance.component.scss'
})
export class ErsAppInstanceComponent {

  instanceArray : any[]= [];
  selectAppName : string = '';
  count: string='';
  showData = false;
  uiMap = {
    isDataLoaded: false,
  };

  
  filterAction() {}

}
